var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconVideo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.25 5C4.38805 5 3.5614 5.34241 2.9519 5.9519C2.34241 6.5614 2 7.38805 2 8.25V15.75C2 16.612 2.34241 17.4386 2.9519 18.0481C3.5614 18.6576 4.38805 19 5.25 19H12.75C13.612 19 14.4386 18.6576 15.0481 18.0481C15.6576 17.4386 16 16.612 16 15.75V15.438L19.258 17.688C20.418 18.488 22.002 17.658 22.002 16.248V7.751C22.002 6.341 20.418 5.509 19.258 6.311L16 8.562V8.25C16 7.38805 15.6576 6.5614 15.0481 5.9519C14.4386 5.34241 13.612 5 12.75 5H5.25ZM16 10.384L20.11 7.546C20.1475 7.52009 20.1915 7.50495 20.237 7.50221C20.2825 7.49947 20.3279 7.50924 20.3683 7.53045C20.4087 7.55167 20.4425 7.58353 20.466 7.62258C20.4896 7.66163 20.502 7.70639 20.502 7.752V16.247C20.502 16.2926 20.4896 16.3374 20.466 16.3764C20.4425 16.4155 20.4087 16.4473 20.3683 16.4685C20.3279 16.4898 20.2825 16.4995 20.237 16.4968C20.1915 16.4941 20.1475 16.4789 20.11 16.453L16 13.615V10.384ZM3.5 8.25C3.5 7.284 4.284 6.5 5.25 6.5H12.75C13.716 6.5 14.5 7.284 14.5 8.25V15.75C14.5 16.2141 14.3156 16.6592 13.9874 16.9874C13.6592 17.3156 13.2141 17.5 12.75 17.5H5.25C4.78587 17.5 4.34075 17.3156 4.01256 16.9874C3.68437 16.6592 3.5 16.2141 3.5 15.75V8.25Z",
    fill: "#344054"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconVideo);
export default __webpack_public_path__ + "static/media/icon_video.fba44398ca0eaf1a435c74aa1d0cb253.svg";
export { ForwardRef as ReactComponent };